import React from 'react';
import styled from 'styled-components';
import { DefinitionList } from '@openfin/ui-library';

import {
  CustomTemplateData,
  TemplateFragment as TemplateFragmentData,
  ListPairs,
} from '../../../../../client/templates/templates';
import { Immutable } from '@openfin/predux';

type Props = {
  fragment: Immutable<TemplateFragmentData>;
  templateData: Immutable<CustomTemplateData>;
  fragmentIndex: number;
  notificationKey: string;
};

export const TemplateFragment: React.FC<Props> = (props) => {
  const { fragment, templateData, fragmentIndex, notificationKey } = props;
  const style: React.CSSProperties = { ...fragment.style };
  const elementKey = `${notificationKey}-f-${fragmentIndex}`;

  if (fragment.type === 'container') {
    return (
      <Container style={style}>
        {fragment.children?.map((c, i) => {
          return (
            <TemplateFragment
              fragment={c}
              templateData={templateData}
              fragmentIndex={fragmentIndex + 1}
              notificationKey={notificationKey}
              key={`${elementKey}-${i}`}
            />
          );
        })}
      </Container>
    );
  }

  const data = templateData[fragment.dataKey];
  switch (fragment.type) {
    case 'text':
      return <Text style={style}>{data}</Text>;
    case 'image':
      return <Image style={style} src={data as string} />;
    case 'list':
      return <List style={style} definitions={new Map(data as ListPairs)} />;
  }
};

const Container = styled.div``;
const Text = styled.span``;
const Image = styled.img``;
const List = styled(DefinitionList)``;
